import * as actionTypes from "../action-types";
import { getInitialAppState } from "../StoreHelpers";
// import moment from "moment";

const appReducer = (state = getInitialAppState(), { type, payload }) => {
    switch (type) {
        case actionTypes.LOADING_FAIL:
            return {
                ...state,
                splashWait: {
                    ...state.splashWait,
                    show: false,
                },
            };
        // case actionTypes.GENERATE_UUID:
        //     return { ...state, quoteNumber: payload };

        // case actionTypes.SET_TOKEN_STATUS:
        //     return { ...state, isTokenExpired: payload };
    
        case actionTypes.RESET_SPLASH_WAIT:
            return {
                ...state,
                splashWait: {
                    ...state.splashWait,
                    show: null,
                },
            };
            
        case actionTypes.VALID_STATUS_EMAIL:
            return {
                ...state,
                formUpdate: {
                    ...state.formUpdate,
                    input: {
                        ...state.formUpdate.input,
                        isValidEmail: payload,
                    }
                }
            };
        
        
        case actionTypes.VALID_STATUS_MOBILE:
            return {
                ...state,
                formUpdate: {
                    ...state.formUpdate,
                    input: {
                        ...state.formUpdate.input,
                        isValidMobile: payload,
                    }
                }
            };
                    
        case actionTypes.SET_SPLASH_WAIT:
            return {
                ...state,
                splashWait: {
                    ...state.splashWait,
                    ...payload,
                },
            };
            
        case actionTypes.SET_STATE:
            return {
                ...state,
                tnc: {
                    ...state.tnc,
                    data: [],
                    state: payload
                },
            };
            
        case actionTypes.API_GET_TNC_SUCCESS:
            return {
                ...state,
                tnc: {
                    ...state.tnc,
                    data: payload.tnc
                },
            };

        default:
            return state;
    }
};

export default appReducer;
